function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import Svg, { Path } from "react-native-svg";
var SvgBrowseIcon = function SvgBrowseIcon(props) {
  return /*#__PURE__*/React.createElement(Svg, _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 21,
    height: 20
  }, props), /*#__PURE__*/React.createElement(Path, {
    fill: "none",
    stroke: props.fillLine,
    d: "M10.1 15.5v-10m0 10L3.6 14V4.5l6.5 1m0 10 6.5-1.5V4.5l-6.5 1"
  }));
};
export default SvgBrowseIcon;